import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";
import { Button } from "@/components/ui/button";
import { Coffee, LogOut, Languages, LayoutDashboard } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

export function Header() {
  const { user, logout } = useAuth();
  const { lang, setLang, t } = useLanguage();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FDFBF7]/85 border-b border-[#E8DFD5]">
      <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between gap-2">
        <Link to="/menu" data-testid="brand-link" className="flex items-center gap-2 min-w-0">
          <span className="w-9 h-9 rounded-full bg-[#4A2C2A] text-[#FDFBF7] flex items-center justify-center shrink-0">
            <Coffee className="w-4 h-4" />
          </span>
          <span className="font-heading font-bold text-lg text-[#4A2C2A] truncate">{t("brand")}</span>
        </Link>
        <div className="flex items-center gap-1 sm:gap-2">
          <Button
            data-testid="lang-switcher"
            variant="ghost"
            size="sm"
            className="gap-1 text-[#786C66]"
            onClick={() => setLang(lang === "it" ? "en" : "it")}
          >
            <Languages className="w-4 h-4" />
            <span className="uppercase text-xs font-bold">{lang === "it" ? "EN" : "IT"}</span>
          </Button>
          {user?.role === "staff" && (
            <Button
              data-testid="staff-area-link"
              variant="ghost"
              size="sm"
              className="gap-1 text-[#786C66]"
              onClick={() => navigate("/staff")}
            >
              <LayoutDashboard className="w-4 h-4" />
              <span className="hidden sm:inline text-xs font-semibold">{t("nav_staff")}</span>
            </Button>
          )}
          {user && (
            <div className="flex items-center gap-2 ml-1">
              {user.picture ? (
                <img src={user.picture} alt={user.name} className="w-8 h-8 rounded-full border border-[#E8DFD5]" />
              ) : (
                <span className="w-8 h-8 rounded-full bg-[#F6F1E9] flex items-center justify-center text-xs font-bold text-[#4A2C2A]">
                  {user.name?.[0]}
                </span>
              )}
              <Button data-testid="logout-btn" variant="ghost" size="icon" onClick={logout} title={t("logout")}>
                <LogOut className="w-4 h-4 text-[#786C66]" />
              </Button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
